export var WalletEvent;
(function (WalletEvent) {
    WalletEvent["ChangeAccount"] = "ChangeAccountEvent";
    WalletEvent["ChangeNetwork"] = "ChangeNetworkEvent";
})(WalletEvent || (WalletEvent = {}));
export var WalletRPC;
(function (WalletRPC) {
    WalletRPC["connect"] = "connect";
    WalletRPC["disconnect"] = "disconnect";
    WalletRPC["isConnected"] = "isConnected";
    WalletRPC["network"] = "network";
    WalletRPC["account"] = "account";
    WalletRPC["chainId"] = "chainId";
    WalletRPC["signAndSubmit"] = "signAndSubmit";
    WalletRPC["signTransaction"] = "signTransaction";
    WalletRPC["signMessage"] = "signMessage";
})(WalletRPC || (WalletRPC = {}));
//# sourceMappingURL=WalletAPI.js.map